export const ANALYTICS_HISTORY_LIMIT = 20

export function advanceAnalyticsHistory(history, name, timestamp = Date.now()) {
    return {
        snapshot: [...history],
        nextHistory: [...history.slice(-(ANALYTICS_HISTORY_LIMIT - 1)), { name, timestamp }],
    }
}
